var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { observer } from 'mobx-react';
import React, { useCallback, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { generateRandomUniquePropertyName } from '../../../../../helpers/RandomGenerator';
import useActiveThemeVariation from '../../../../themes/hooks/UseActiveThemeVariation';
import Text from '../../../core/text/TextComponent';
import ScrollView from '../../../layouts/scrollView/ScrollViewComponent';
import StackLayout from '../../../layouts/stackLayout/StackLayoutComponent';
import Icon from '../../icon/IconComponent';
import useModalStore from '../dataLayer/hooks/UseModalStore';
import { invokeEventHandler } from '../../../../../helpers/ReactShortcuts';
var ModalImplementation = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var modalKey = props.modalKey, icon = props.icon, title = props.title, children = props.children, onSave = props.onSave, onClosePressed = props.onClosePressed, onOpened = props.onOpened;
    var _g = __read(useState(generateRandomUniquePropertyName()), 1), modalId = _g[0];
    var modalStore = useModalStore();
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.advancedControlsThemes.modal; });
    var handleClosePress = useCallback(function () {
        modalStore.closeModal();
        invokeEventHandler(onClosePressed);
    }, [onClosePressed]);
    return (React.createElement(Modal, { id: modalId, open: modalStore.showModal(modalKey), onMount: onOpened, closeOnDimmerClick: true, style: activeThemeVariation.widthFitContent ? { width: 'fit-content' } : undefined },
        React.createElement(StackLayout, __assign({}, activeThemeVariation.container),
            React.createElement(StackLayout, __assign({ horizontal: true, vCenter: true }, activeThemeVariation.header),
                onSave ? (React.createElement(StackLayout, { onPress: handleClosePress, stretch: true },
                    React.createElement(Text, { variationKey: (_a = activeThemeVariation.header) === null || _a === void 0 ? void 0 : _a.closeTextVariation }, 'Cancel'))) : icon ? (React.createElement(Icon, { icon: icon, variationKey: (_b = activeThemeVariation.header) === null || _b === void 0 ? void 0 : _b.iconVariation })) : null,
                React.createElement(Text, { stretch: onSave === undefined, overflowEllipsis: true, variationKey: (_c = activeThemeVariation.header) === null || _c === void 0 ? void 0 : _c.titleVariation }, title),
                onSave ? (React.createElement(StackLayout, { onPress: onSave, stretch: true, hEnd: true },
                    React.createElement(Text, { variationKey: (_d = activeThemeVariation.header) === null || _d === void 0 ? void 0 : _d.saveTextVariation }, 'Save'))) : React.createElement(Icon, { onPress: modalStore.closeModal, icon: (_e = activeThemeVariation.header) === null || _e === void 0 ? void 0 : _e.closeIcon, variationKey: (_f = activeThemeVariation.header) === null || _f === void 0 ? void 0 : _f.closeIconVariation })),
            React.createElement(ScrollView, __assign({}, activeThemeVariation.content), children))));
};
export default observer(ModalImplementation);
//# sourceMappingURL=ModalImplementation.js.map